/**
 * Save the parameters locally for page refreshes.
 * @param  {object} inputs   List of all checkboxes and search input.
 * @param  {string} blockId  The block id.
 */
export const setParams = (inputs, blockId, page = 1) => {
	const block = document.getElementById(blockId);
	const listings = block.querySelector('.em-filterable-content__listings');
	const filterContainer = block.querySelector('.em-filterable-content__filter-container');
	const { localStorage } = window;

	// Set default parameters from the block filter container.
	const params = {
		paged: page,
	};

	// This shouldn't be hardcoded, but it'll work for now. @todo update.
	if (window.location.href.indexOf('/about-us/webinars/') !== -1) {
		params.webinars_only = true;
		params.show_past = true;
	}

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		if (e.id === 'show-past') {
			if (e.checked) {
				params.show_past = true;
			}
			// but we don't want this to be treated as a taxonomy, so move on.
			return;
		}

		const tax = e.getAttribute('data');

		// If is checked set the tax parameters.
		if (e.checked && e.id !== 'compact-view') {
			if (tax) {
				if (params[tax] !== undefined) {
					params[tax].push(e.value);
				} else {
					params[tax] = [e.value];
				}
			} else {
				params[e.name] = e.value;

				if (e.id === 'favorite_docs') {
					const favorites = localStorage.getItem('favoriteDocuments');
					params[e.name] = JSON.parse(favorites);
				}
			}
		}

		// If is search set the search parameter.
		if (e.classList.contains('filter-search')) {
			if (e.value) {
				params.search = e.value;
				listings.scrollIntoView({ behavior: 'smooth' });
			}
		}

		if (e.id === 'document-orderby') {
			if (e.value) {
				params.orderby = e.value;
				filterContainer.setAttribute('data-orderby', e.value);
			}
		}
	});

	// console.log('setParams params', params);
	return params;
};

function currentUrl(query = false) {
	let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
	if (query) {
		newUrl += `?${query}`;
	}
	return newUrl;
}

/**
 * Get the saved parameters.
 * @param  {string} blockId the block id.
 */
export const getParams = (blockId, getNew = false, page = 1) => {
	let params;
	const block = document.getElementById(blockId);
	const filterContainer = block.querySelector('.em-filterable-content__filter-container');
	const urlParams = new URLSearchParams(window.location.search);
	const urlParamsObj = {};

	urlParams.forEach((value, key) => {
		urlParamsObj[key] = value;
	});

	if (Object.keys(urlParamsObj).length < 1) {
		getNew = true;
	}

	if (getNew) {
		const inputs = block.querySelectorAll('[type="checkbox"], .filter-search');
		params = setParams(inputs, blockId, page);
		const newUrl = currentUrl(new URLSearchParams(params).toString());
		window.history.pushState({ path: newUrl }, '', newUrl);
	} else {
		params = urlParamsObj;
	}

	// Add default params after push state.
	const defaultParams = {
		block: blockId,
		post_type: filterContainer.getAttribute('data-post-types'),
		orderby: filterContainer.getAttribute('data-orderby'),
		order: filterContainer.getAttribute('data-order'),
		paged: filterContainer.getAttribute('data-page'),
		pagination: filterContainer.getAttribute('data-pagination'),
	};

	const finalParams = {
		...defaultParams,
		...params,
	};

	return finalParams;
};
